type EnvConfig = {
  env: 'dev' | 'staging' | 'v1';
  basePath: string;
};

const ORIGIN_MAP: Record<string, EnvConfig> = {
  'https://dev.foodworks.org': {
    env: 'dev',
    basePath: 'https://czb8fru7ij.execute-api.us-east-1.amazonaws.com/dev',
  },
  'https://staging.foodworks.org': {
    env: 'staging',
    basePath: 'https://a1vtgusl3m.execute-api.us-east-1.amazonaws.com/staging',
  },
  'https://app.foodworks.org': {
    env: 'v1',
    basePath: 'https://fg74jjx1x7.execute-api.us-east-1.amazonaws.com/v1',
  },
};

function getConfig(): EnvConfig {
  const { origin } = window.location;
  return ORIGIN_MAP[origin] ?? ORIGIN_MAP['https://dev.foodworks.org'];
}

const { env, basePath } = getConfig();

export default {
  env,
  basePath,
  sector: 'wjgOXd6Xl0UGZqwW9JOzuozKKwROzmtWYeml5B0BI95lz6N8NvsZ1jOkdNw2TloXQmjXPJHy74zy',
  realm: 'GM8Wz28q65SvlX1R609JCrMJre4wqRTXONoLKLMP',
  multigroup: '11J3gKPg8BCR3mr5OO92S6EBL4ddlAioeearoJdLcEzAMD43lBsj7pOvDYMeur304pK8kkC7pdqeJpvQCM3',
};
